import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-studenteducationalbackground',
  templateUrl: './studenteducationalbackground.component.html',
  styleUrls: ['./studenteducationalbackground.component.css']
})
export class StudenteducationalbackgroundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
